import { useState } from "react"
import { BookOpen } from "lucide-react"
import { cn } from "@/lib/utils"

/**
 * Course cover from Active Storage; on load failure shows BookOpen fallback
 * so missing or stale blobs do not leave a broken-image icon.
 */
export function CourseCoverImage({
  url,
  alt = "",
  wrapperClassName,
  imgClassName = "w-full h-full object-cover",
  fallbackIconClassName = "h-4 w-4 text-zinc-300",
}) {
  const [failed, setFailed] = useState(false)
  const showImg = Boolean(url) && !failed

  return (
    <div
      className={cn(
        wrapperClassName,
        !showImg && "flex items-center justify-center bg-zinc-100"
      )}
    >
      {showImg ? (
        <img
          src={url}
          alt={alt}
          className={imgClassName}
          onError={() => setFailed(true)}
        />
      ) : (
        <BookOpen className={fallbackIconClassName} aria-hidden />
      )}
    </div>
  )
}
